const items = [
  "Rencontres 100% Ivoiriennes",
  "Abidjan — Bouaké — Yamoussoukro — San-Pédro",
  "FodindinLago · Libres & Connectés",
  "FodindinLove · L'Amour Vrai",
  "FodindinClubVIP · Luxe & Exclusivité",
  "Profils vérifiés & discrétion assurée",
];

export const Marquee = () => (
  <div className="bg-[#0A5C36] py-4 overflow-hidden border-y border-[#D4AF37]/30" data-testid="editorial-marquee">
    <div className="marquee-track">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-heading text-sm sm:text-base font-semibold tracking-[0.2em] uppercase text-[#FAF8F5] whitespace-nowrap px-8">
            {item}
          </span>
          <span className="w-2 h-2 rounded-full bg-[#D4AF37] shrink-0" />
        </span>
      ))}
    </div>
  </div>
);
